var _style, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEsfera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1800 1800",
    style: {
      enableBackground: "new 0 0 1800 1800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:url(#SVGID_1_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st1{enable-background:new    ;}\r\n\t.st2{fill:none;stroke:url(#SVGID_00000054235337775062980940000013881784954971265947_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:url(#SVGID_00000089561133137782027690000011772864233298048158_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:url(#SVGID_00000052070821113913495620000008559992429907346091_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:url(#SVGID_00000179641636606247682000000007292825943733657754_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st6{fill:none;stroke:url(#SVGID_00000124135352578474562620000010628981942184321214_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:url(#SVGID_00000083051771120598696970000001172534976304902068_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st8{fill:none;stroke:url(#SVGID_00000076599411808799675470000007582850896212467132_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st9{fill:none;stroke:url(#SVGID_00000025441085742245881660000008015118509581699237_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st10{fill:none;stroke:url(#SVGID_00000097468985184661892210000015004624381328784789_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st11{fill:none;stroke:url(#SVGID_00000172430795604380902250000009147980814755241656_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:url(#SVGID_00000159437021036285239220000001011452938445806465_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:url(#SVGID_00000079458519571724419280000003990840307931963069_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:url(#SVGID_00000155140174489852854030000007263067370599429034_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st15{fill:none;stroke:url(#SVGID_00000145024900177709276670000008963863576185419665_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st16{fill:none;stroke:url(#SVGID_00000120560059592221265460000001216491941431577747_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st17{fill:none;stroke:url(#SVGID_00000060027718785123506930000015193896207732568761_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st18{fill:none;stroke:url(#SVGID_00000119811015188257708530000005097473760741105569_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st19{fill:none;stroke:url(#SVGID_00000012433287171394101860000013819892959081873850_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st20{fill:none;stroke:url(#SVGID_00000044885103696991254500000010855847258426160783_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st21{fill:none;stroke:url(#SVGID_00000013174711316595653050000014440310464421586612_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st22{fill:none;stroke:url(#SVGID_00000179606672325394162920000003726053911617940909_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st23{fill:none;stroke:url(#SVGID_00000080164984942138635990000006390987218904124802_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st24{fill:none;stroke:url(#SVGID_00000060002109799285149340000015705596997824824740_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st25{fill:none;stroke:url(#SVGID_00000067216064335542651960000010253913346689063348_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st26{fill:none;stroke:url(#SVGID_00000072274695481942508690000007738107366924921775_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st27{fill:none;stroke:url(#SVGID_00000098942458306926208260000015206911720457481353_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st28{fill:none;stroke:url(#SVGID_00000153665065822644317810000016830491634413399465_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st29{fill:none;stroke:url(#SVGID_00000101073735972721498170000011708677860914354348_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st30{fill:none;stroke:url(#SVGID_00000116217041591210690980000006142606853766256043_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st31{fill:none;stroke:url(#SVGID_00000067937881210659104240000001505991877707696773_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st32{fill:none;stroke:url(#SVGID_00000094607005117534452800000012526642645621283729_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st33{fill:none;stroke:url(#SVGID_00000084497343172857879860000004591941623587709330_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st34{fill:none;stroke:url(#SVGID_00000129884229091466175060000017702835247990765482_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st35{fill:none;stroke:url(#SVGID_00000000904912231119233660000016784393120559363232_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st36{fill:none;stroke:url(#SVGID_00000149374432346649782380000006829197231815112864_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st37{fill:none;stroke:url(#SVGID_00000005977945330793012210000016851012097067310500_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st38{fill:none;stroke:url(#SVGID_00000172407645768947884020000007843283016738826388_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st39{fill:none;stroke:url(#SVGID_00000034090390912638147490000009136451846429211553_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st40{fill:none;stroke:url(#SVGID_00000127762946228468552780000017067328990869289919_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st41{fill:none;stroke:url(#SVGID_00000049935381181657564200000008346778767532630427_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st42{fill:none;stroke:url(#SVGID_00000023260844035424617700000014580524879667791506_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st43{fill:none;stroke:url(#SVGID_00000171695928168104080430000005119620320748275104_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st44{fill:none;stroke:url(#SVGID_00000150088990189146626380000012284466040509431938_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st45{fill:none;stroke:url(#SVGID_00000116200135202545821460000002145964181063293625_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st46{fill:none;stroke:url(#SVGID_00000177481386840440994510000011470331995981817252_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st47{fill:none;stroke:url(#SVGID_00000077313106301668009720000012752571754465195653_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st48{fill:none;stroke:url(#SVGID_00000072999748790153700260000015164192668723571072_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st49{fill:none;stroke:url(#SVGID_00000122715283700429423980000004116904545589984670_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st50{fill:none;stroke:url(#SVGID_00000014606629650129827770000017226180093674610845_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st51{fill:none;stroke:url(#SVGID_00000128486612980116455110000012178152055948643987_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st52{fill:none;stroke:url(#SVGID_00000125603708680648510360000017007129506122164882_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st53{fill:none;stroke:url(#SVGID_00000117659439732667342220000008146319023744753572_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st54{fill:none;stroke:url(#SVGID_00000039820636880604818060000004995814844050983829_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st55{fill:none;stroke:url(#SVGID_00000127037661882794046780000001336594405155079563_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st56{fill:none;stroke:url(#SVGID_00000101798159968028820390000005980632397907691923_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st57{fill:none;stroke:url(#SVGID_00000132063133952691447990000004877237041822258106_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st58{fill:none;stroke:url(#SVGID_00000176734415868690318600000008676381786657662348_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st59{fill:none;stroke:url(#SVGID_00000093869869809904514870000015566734780413001391_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st60{fill:none;stroke:url(#SVGID_00000005973324724692661370000006498185193076699562_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st61{fill:none;stroke:url(#SVGID_00000152242680582736822270000005256949193239287728_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st62{fill:none;stroke:url(#SVGID_00000010301231323386416290000008316959393664763831_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st63{fill:none;stroke:url(#SVGID_00000129888943461347476200000012847982154750812850_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st64{fill:none;stroke:url(#SVGID_00000033333389258019407420000018231635990622096272_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st65{fill:none;stroke:url(#SVGID_00000025413113747864586240000004149181139228864673_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st66{fill:none;stroke:url(#SVGID_00000060025000225312402720000005137172242638412970_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st67{fill:none;stroke:url(#SVGID_00000068649259773329845130000006498433442394013573_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st68{fill:none;stroke:url(#SVGID_00000070816044642546034060000005884874946061631125_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st69{fill:none;stroke:url(#SVGID_00000078016989623583865830000010193615258483154601_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st70{fill:none;stroke:url(#SVGID_00000096060366169424820520000013788791493211276430_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st71{fill:none;stroke:url(#SVGID_00000139255705734744929400000014587963200791119262_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st72{fill:none;stroke:url(#SVGID_00000134951719569422623610000009565933636802857902_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st73{fill:none;stroke:url(#SVGID_00000111912001713628012930000008707548735483718799_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st74{fill:none;stroke:url(#SVGID_00000137092810100945595990000002957032131611627690_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st75{fill:none;stroke:url(#SVGID_00000057121068709941053760000003643469717683745968_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st76{fill:none;stroke:url(#SVGID_00000035493585361562265670000000892439195648697473_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st77{fill:none;stroke:url(#SVGID_00000157987095844560953180000017774933955696875187_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st78{fill:none;stroke:url(#SVGID_00000125602157703632796410000010817558349910089368_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st79{fill:none;stroke:url(#SVGID_00000182496998501598927940000005591124771875283388_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st80{fill:none;stroke:url(#SVGID_00000099624601503181671730000018139677185573962427_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st81{fill:none;stroke:url(#SVGID_00000133513322229024454680000011622972845767298715_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st82{fill:none;stroke:url(#SVGID_00000036221860639510963550000014700271779226995622_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st83{fill:none;stroke:url(#SVGID_00000023266557717926353230000011994230606194483632_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st84{fill:none;stroke:url(#SVGID_00000181071903811138259070000017893085449979904668_);stroke-width:7;stroke-miterlimit:10;}\r\n\t.st85{fill:none;stroke:url(#SVGID_00000121263762095943350720000000725252533378850489_);stroke-width:7;stroke-miterlimit:10;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.6554,
    y1: 1629.249,
    x2: 1381.8707,
    y2: 167.0251,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 900,
    cy: 900,
    r: 840.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120521395942980669850000002684909162135323321_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.3486,
    y1: 1628.9651,
    x2: 1381.5026,
    y2: 166.8476,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000120521395942980669850000002684909162135323321_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1512.2,1476.5c-15.6,17.1-37.7,38.9-55.5,53.7c-28.7,24-67.5,55.8-99.3,75.5c-33.1,20.4-78.5,45.6-113.8,61.9 c-30,13.8-71.3,29.6-103.2,38.3c-27.9,7.6-65.1,17.9-93.6,22.1c-18,2.7-41.9,6.7-60.1,8.4c-24.4,2.2-57.1,4.3-81.7,4.4 c-62.1,0.1-104.5-5.9-127.4-9.1c-16.4-2.3-38.1-6.3-54.2-9.9c-17.9-3.9-41.8-9.4-59.2-15c-14.8-4.8-34.7-10.8-49.4-16.1 c-15-5.4-34.8-12.9-49.3-19.5c-13-5.9-30.5-13.4-43.1-20.1c-12.3-6.6-28.8-15-40.8-21.9c-11.8-6.8-27.4-16.2-38.8-23.7 c-22.6-14.8-57.7-38.4-102.3-78.1c-18.8-16.8-42.3-40.8-59.8-59c-8.9-9.3-19.8-22.5-28.2-32.3c-8.6-10.1-19.4-24.2-27.3-34.8 c-7.9-10.6-17.8-25.2-25.4-36c-7.7-11-16.8-26.5-23.8-38c-8-12.9-17.4-30.7-24.3-44.1c-6.6-12.8-14.9-30.1-20.7-43.3 c-7-16.1-15.9-37.8-21.8-54.3c-6.8-19.1-14.9-45-20.4-64.5c-9.2-32.6-16.7-77.3-22.3-110.8C53.2,909.1,91.6,800.1,187.9,697.9 c241.7-256.5,757.7-374.4,1150.4-263c-392.6-111.4-908.7,6.6-1150.4,263C91.6,800.1,53.2,909.1,66.6,1010.3 c-7.7-60.6-7.5-94.2-7.2-129.7c0.2-31.6,4-73.8,8.8-105C74,738.2,85,688.7,96,652.5c10.6-34.8,27.4-80.6,43.9-113 c17.5-34.5,42.3-79.9,64.1-111.8c22.6-33.1,56.1-75,83.6-104.1c46.7-49.3,82.9-77.2,106.9-95.7c29.3-22.6,71.6-48.6,103.8-66.8 c29.1-16.4,69.9-34.9,101.2-46.6c35.2-13.1,83.4-27.8,120.1-35.8c27.7-6.1,65.1-12.8,93.3-15c17.9-1.4,41.7-3.6,59.7-4 c24-0.5,56-0.8,79.9,1.3c17.1,1.5,39.9,3.2,56.8,5.6c20.2,2.8,47,7.5,66.9,11.7c42.9,8.9,92.7,24.9,108.6,31.1 c14.8,5.8,34.9,12.8,49.3,19.5c25.6,11.8,59.4,28.3,83.9,42.1c11.9,6.7,27.5,16,38.8,23.7c10.8,7.4,25.4,17,36,24.7 c10.4,7.5,24,17.9,34,26c116,93.5,184.3,199.3,221.1,271.6c7.6,14.9,17.1,35.1,23.8,50.4c6.1,14,13.2,33,18.7,47.2 c7.3,18.9,15.1,44.9,20.4,64.5c8.8,32.8,17,77.3,22.3,110.8c3.3,20.6,4.9,48.4,6.4,69.2c2.7,39,0.8,110.2-7.9,165.5 c-12.2,77-25.3,119.5-46.2,176.5c-6.7,18.2-16.5,42.4-25.5,59.6c-17.9,34.3-43.5,79.1-64.1,111.8 C1574.6,1406.3,1539.2,1446.8,1512.2,1476.5z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002382398609984357510000013442925110615980690_",
    gradientUnits: "userSpaceOnUse",
    x1: 553.7545,
    y1: 1321.4929,
    x2: 1151.5201,
    y2: 286.1324,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000002382398609984357510000013442925110615980690_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c-392.6-111.4-908.7,6.6-1150.4,263c49.3,370.5,408.2,761.3,801.4,872.9C1231,1314.3,1387.5,804.8,1338.3,434.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082344648654328385500000013713314361907350948_",
    gradientUnits: "userSpaceOnUse",
    x1: 1126.1633,
    y1: 707.9829,
    x2: 1226.094,
    y2: 534.8979,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000082344648654328385500000013713314361907350948_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M919.2,396.6c24.9,186.8,205.8,383.9,404.2,440.2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126302488603245763020000016696719502231382158_",
    gradientUnits: "userSpaceOnUse",
    x1: 819.8329,
    y1: 1023.5568,
    x2: 988.884,
    y2: 730.7518,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000126302488603245763020000016696719502231382158_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M506.3,491c42.6,319.8,352.4,657.2,691.9,753.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083073019843509133700000000723547021689544609_",
    gradientUnits: "userSpaceOnUse",
    x1: 630.9866,
    y1: 1202.2642,
    x2: 1157.0531,
    y2: 291.0903,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000083073019843509133700000000723547021689544609_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9C1024.1,525.3,571.9,807.6,330.2,1064"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139972745411826676170000012572580641710737082_",
    gradientUnits: "userSpaceOnUse",
    x1: 743.3071,
    y1: 1414.2717,
    x2: 1331.8997,
    y2: 394.7996,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000139972745411826676170000012572580641710737082_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c-155.6,263.1-478.9,685.9-720.5,942.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168816301827405546450000015653021366809925055_",
    gradientUnits: "userSpaceOnUse",
    x1: 1110.3566,
    y1: 1609.845,
    x2: 1706.5432,
    y2: 577.2196,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000168816301827405546450000015653021366809925055_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c49.3,369.9-107.3,879.5-348.9,1135.9c393.3,111.6,672.1-98.2,622.7-468.7 C1853.7,845.6,1730.9,546.3,1338.3,434.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087391829631631649500000005904759087681617325_",
    gradientUnits: "userSpaceOnUse",
    x1: 1473.3048,
    y1: 890.8799,
    x2: 1656.9423,
    y2: 572.8106,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000087391829631631649500000005904759087681617325_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1323.4,836.8c198.3,56.3,338.9-49.5,314.1-236.4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152972318131432985840000008664709024290232463_",
    gradientUnits: "userSpaceOnUse",
    x1: 1412.6083,
    y1: 1335.8844,
    x2: 1724.9816,
    y2: 794.838,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000152972318131432985840000008664709024290232463_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1198.1,1244.5c339.5,96.4,580.2-84.8,537.6-404.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029029297397115401340000009798820099846366127_",
    gradientUnits: "userSpaceOnUse",
    x1: 1155.6547,
    y1: 1441.3367,
    x2: 1654.4158,
    y2: 577.4571,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000029029297397115401340000009798820099846366127_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c240.7,375.6,239.9,889.9-1.7,1146.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047754053441067351620000017036362651943479229_",
    gradientUnits: "userSpaceOnUse",
    x1: 1331.3459,
    y1: 1245.6332,
    x2: 1701.6212,
    y2: 604.2975,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000047754053441067351620000017036362651943479229_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c363.9,282.9,463.3,721.7,221.7,978.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177452433203852508720000007949652685708560060_",
    gradientUnits: "userSpaceOnUse",
    x1: 1184.2812,
    y1: 827.917,
    x2: 1509.9171,
    y2: 263.899,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000177452433203852508720000007949652685708560060_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c392.6,111.4,515.5,410.7,273.8,667.2c-49.3-370.5-408.2-761.3-801.4-872.9C1052.3-27.3,1289,65,1338.3,434.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010999423615601334020000000646468077459880372_",
    gradientUnits: "userSpaceOnUse",
    x1: 1450.1067,
    y1: 458.3242,
    x2: 1550.0377,
    y2: 285.2386,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000010999423615601334020000000646468077459880372_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1637.5,600.4c-24.9-186.8-205.8-383.9-404.2-440.2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060721893638471129300000007216524557522308754_",
    gradientUnits: "userSpaceOnUse",
    x1: 1372.675,
    y1: 596.3639,
    x2: 1541.7264,
    y2: 303.5584,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000060721893638471129300000007216524557522308754_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1735.7,839.9c-42.6-319.8-352.4-657.2-691.9-753.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181052734910901697120000011659964032293033392_",
    gradientUnits: "userSpaceOnUse",
    x1: 1426.1011,
    y1: 675.2684,
    x2: 1591.8363,
    y2: 388.2065,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000181052734910901697120000011659964032293033392_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c314.2-90.5,373.2,44.6,131.5,301"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111881015236706979180000014905724495092836995_",
    gradientUnits: "userSpaceOnUse",
    x1: 1302.8271,
    y1: 456.9375,
    x2: 1444.1643,
    y2: 212.1345,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000111881015236706979180000014905724495092836995_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c155.6-263.1,85.6-268.6-156-12.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000109017542654031455580000017260628589896191674_",
    gradientUnits: "userSpaceOnUse",
    x1: 571.4208,
    y1: 892.1445,
    x2: 1078.0831,
    y2: 14.5796,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000109017542654031455580000017260628589896191674_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9C1289,65,1052.3-27.3,810.6,229.2c-393.3-111.6-672.1,98.2-622.7,468.7C429.6,441.4,945.6,323.4,1338.3,434.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078014423536283161020000010308129119621411209_",
    gradientUnits: "userSpaceOnUse",
    x1: 1019.2583,
    y1: 420.4115,
    x2: 1202.8962,
    y2: 102.3413,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000078014423536283161020000010308129119621411209_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1233.3,160.2c-198.3-56.3-339,49.5-314.1,236.4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031182444672918351250000014924933836544948113_",
    gradientUnits: "userSpaceOnUse",
    x1: 636.5771,
    y1: 532.2776,
    x2: 948.9507,
    y2: -8.7693,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000031182444672918351250000014924933836544948113_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1043.9,86.3C704.4-10,463.7,171.1,506.3,491"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020363105237358209560000012592739224080399528_",
    gradientUnits: "userSpaceOnUse",
    x1: 896.8682,
    y1: 433.5604,
    x2: 1075.3606,
    y2: 124.4025,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000020363105237358209560000012592739224080399528_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9C1097.6,59.3,705.1-37.7,463.4,218.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047056798286809967570000001833293949160070538_",
    gradientUnits: "userSpaceOnUse",
    x1: 720.3411,
    y1: 628.7814,
    x2: 981.5249,
    y2: 176.3977,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000047056798286809967570000001833293949160070538_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9C974.4,152,481.7,130.5,240,386.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018925099775399717480000015978379292621033151_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.5744,
    y1: 1532.3337,
    x2: 735.2106,
    y2: 968.3152,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000018925099775399717480000015978379292621033151_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M187.9,697.9c-241.7,256.5-118.8,555.8,273.8,667.2c49.3,369.9,286,462.2,527.6,205.7C596,1459.2,237.2,1068.4,187.9,697.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158748855587025004880000017124564320381477286_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.7655,
    y1: 1492.6748,
    x2: 546.8171,
    y2: 1199.8689,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000158748855587025004880000017124564320381477286_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M64.2,960.1c42.6,319.8,352.3,657.2,691.9,753.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115476094514408113620000009409016242534380675_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.6547,
    y1: 1408.0264,
    x2: 493.3905,
    y2: 1120.9636,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000115476094514408113620000009409016242534380675_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M330.2,1064c-241.7,256.5-182.7,391.5,131.5,301"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005258057488039876350000017470393243657260453_",
    gradientUnits: "userSpaceOnUse",
    x1: 475.3268,
    y1: 1584.0977,
    x2: 616.6638,
    y2: 1339.2948,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000005258057488039876350000017470393243657260453_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M617.7,1377.2c-241.7,256.5-311.7,251-156-12.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119822350819318264740000000143273908476860605_",
    gradientUnits: "userSpaceOnUse",
    x1: 841.408,
    y1: 1781.653,
    x2: 1348.0707,
    y2: 904.0874,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000119822350819318264740000000143273908476860605_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M989.3,1570.8C747.7,1827.2,511,1735,461.7,1365.1c392.6,111.4,908.7-6.6,1150.4-263C1661.4,1472.6,1382.6,1682.4,989.3,1570.8 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020363356970824804030000014604606965215735737_",
    gradientUnits: "userSpaceOnUse",
    x1: 970.5405,
    y1: 1805.0022,
    x2: 1282.9138,
    y2: 1263.9557,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000020363356970824804030000014604606965215735737_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M756.1,1713.6c339.5,96.4,580.2-84.8,537.6-404.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052067583618444390380000004885463211738740872_",
    gradientUnits: "userSpaceOnUse",
    x1: 844.1307,
    y1: 1671.8302,
    x2: 1022.6234,
    y2: 1362.6716,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000052067583618444390380000004885463211738740872_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1336.5,1581.2c-241.7,256.5-634.1,159.5-874.8-216.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176014219893262198780000017689105626040694166_",
    gradientUnits: "userSpaceOnUse",
    x1: 937.9666,
    y1: 1619.8345,
    x2: 1199.1505,
    y2: 1167.4507,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000176014219893262198780000017689105626040694166_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1559.9,1413.1c-241.7,256.5-734.3,234.9-1098.2-48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104703887682388417460000006022111987161986689_",
    gradientUnits: "userSpaceOnUse",
    x1: 767.9717,
    y1: 1510.0997,
    x2: 1365.7371,
    y2: 474.7397,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000104703887682388417460000006022111987161986689_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1612.1,1102.1c-241.7,256.5-757.7,374.4-1150.4,263C412.4,995.2,569,485.6,810.6,229.2 C1203.9,340.8,1562.7,731.6,1612.1,1102.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021088106219084861220000011529100600136259458_",
    gradientUnits: "userSpaceOnUse",
    x1: 930.6066,
    y1: 1065.4812,
    x2: 1099.658,
    y2: 772.6758,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000021088106219084861220000011529100600136259458_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1293.7,1309c-42.6-319.8-352.4-657.2-691.9-753.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151525010971476469140000009193679506199752879_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.4385,
    y1: 1505.1418,
    x2: 1288.505,
    y2: 593.9679,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000151525010971476469140000009193679506199752879_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1469.8,735.9c-241.7,256.5-693.9,538.7-1008.1,629.2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013873918113754470020000010063548529098553748_",
    gradientUnits: "userSpaceOnUse",
    x1: 587.5916,
    y1: 1401.4323,
    x2: 1176.184,
    y2: 381.9605,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000013873918113754470020000010063548529098553748_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1182.2,422.8c-241.7,256.5-564.9,679.2-720.5,942.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070816710978598715480000002222290227114938273_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.9484,
    y1: 1219.0123,
    x2: 809.1345,
    y2: 186.3877,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000070816710978598715480000002222290227114938273_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M810.6,229.2C569,485.6,412.4,995.2,461.7,1365.1C69.1,1253.6-53.8,954.3,187.9,697.9C138.5,327.4,417.4,117.6,810.6,229.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007402647623162750010000005082757395640417155_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.5099,
    y1: 1001.3945,
    x2: 506.8828,
    y2: 460.3488,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000007402647623162750010000005082757395640417155_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M601.8,555.4C262.3,459.1,21.6,640.3,64.2,960.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065797083759567148340000005059724133242973111_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.0759,
    y1: 1218.7749,
    x2: 763.837,
    y2: 354.8954,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000065797083759567148340000005059724133242973111_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M463.4,218.8C221.8,475.2,221,989.5,461.7,1365.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114784097123575697420000009014933431500467849_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.8704,
    y1: 1191.9346,
    x2: 588.1457,
    y2: 550.5989,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000114784097123575697420000009014933431500467849_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M240,386.9C-1.6,643.4,97.8,1082.2,461.7,1365.1"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000110444244750975651070000013423840203058956706_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.3486,
    y1: 1628.9651,
    x2: 1381.5026,
    y2: 166.8476,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000110444244750975651070000013423840203058956706_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1512.2,1476.5c-15.6,17.1-37.7,38.9-55.5,53.7c-28.7,24-67.5,55.8-99.3,75.5c-33.1,20.4-78.5,45.6-113.8,61.9 c-30,13.8-71.3,29.6-103.2,38.3c-27.9,7.6-65.1,17.9-93.6,22.1c-18,2.7-41.9,6.7-60.1,8.4c-24.4,2.2-57.1,4.3-81.7,4.4 c-62.1,0.1-104.5-5.9-127.4-9.1c-16.4-2.3-38.1-6.3-54.2-9.9c-17.9-3.9-41.8-9.4-59.2-15c-14.8-4.8-34.7-10.8-49.4-16.1 c-15-5.4-34.8-12.9-49.3-19.5c-13-5.9-30.5-13.4-43.1-20.1c-12.3-6.6-28.8-15-40.8-21.9c-11.8-6.8-27.4-16.2-38.8-23.7 c-22.6-14.8-57.7-38.4-102.3-78.1c-18.8-16.8-42.3-40.8-59.8-59c-8.9-9.3-19.8-22.5-28.2-32.3c-8.6-10.1-19.4-24.2-27.3-34.8 c-7.9-10.6-17.8-25.2-25.4-36c-7.7-11-16.8-26.5-23.8-38c-8-12.9-17.4-30.7-24.3-44.1c-6.6-12.8-14.9-30.1-20.7-43.3 c-7-16.1-15.9-37.8-21.8-54.3c-6.8-19.1-14.9-45-20.4-64.5c-9.2-32.6-16.7-77.3-22.3-110.8C53.2,909.1,91.6,800.1,187.9,697.9 c241.7-256.5,757.7-374.4,1150.4-263c-392.6-111.4-908.7,6.6-1150.4,263C91.6,800.1,53.2,909.1,66.6,1010.3 c-7.7-60.6-7.5-94.2-7.2-129.7c0.2-31.6,4-73.8,8.8-105C74,738.2,85,688.7,96,652.5c10.6-34.8,27.4-80.6,43.9-113 c17.5-34.5,42.3-79.9,64.1-111.8c22.6-33.1,56.1-75,83.6-104.1c46.7-49.3,82.9-77.2,106.9-95.7c29.3-22.6,71.6-48.6,103.8-66.8 c29.1-16.4,69.9-34.9,101.2-46.6c35.2-13.1,83.4-27.8,120.1-35.8c27.7-6.1,65.1-12.8,93.3-15c17.9-1.4,41.7-3.6,59.7-4 c24-0.5,56-0.8,79.9,1.3c17.1,1.5,39.9,3.2,56.8,5.6c20.2,2.8,47,7.5,66.9,11.7c42.9,8.9,92.7,24.9,108.6,31.1 c14.8,5.8,34.9,12.8,49.3,19.5c25.6,11.8,59.4,28.3,83.9,42.1c11.9,6.7,27.5,16,38.8,23.7c10.8,7.4,25.4,17,36,24.7 c10.4,7.5,24,17.9,34,26c116,93.5,184.3,199.3,221.1,271.6c7.6,14.9,17.1,35.1,23.8,50.4c6.1,14,13.2,33,18.7,47.2 c7.3,18.9,15.1,44.9,20.4,64.5c8.8,32.8,17,77.3,22.3,110.8c3.3,20.6,4.9,48.4,6.4,69.2c2.7,39,0.8,110.2-7.9,165.5 c-12.2,77-25.3,119.5-46.2,176.5c-6.7,18.2-16.5,42.4-25.5,59.6c-17.9,34.3-43.5,79.1-64.1,111.8 C1574.6,1406.3,1539.2,1446.8,1512.2,1476.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047743714658173814170000001310874511215096223_",
    gradientUnits: "userSpaceOnUse",
    x1: 537.6674,
    y1: 1629.1765,
    x2: 1381.8235,
    y2: 167.0553,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000047743714658173814170000001310874511215096223_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1733.3,789.6c4.3,35.7,8,83.8,7.4,119.7c-0.9,49.8-3.8,83-11.8,132.7c-5.1,32.1-15.1,74.4-25,105.4 c-11.8,36.9-29.6,85.7-47.3,120.1c-16.9,33-41,76.3-62.1,106.8c-22.4,32.4-55,73.8-82.3,102.1c-27.8,28.8-67.1,65.3-98.9,89.6 c-48.7,37.2-76.4,52.8-118.2,76.3c-31.6,17.8-76.4,36.5-110.4,49c-30.6,11.3-72.5,23.9-104.5,30.1c-35.7,6.9-83.7,15.3-120,17.3 c-27.3,1.5-63.8,2-91.2,1.5c-17.2-0.3-40.1-2.5-57.3-4.2c-22.9-2.2-53.2-7.4-75.8-11.6c-16.1-3-37.4-8.4-53.2-12.5 c-18.8-4.8-43.4-12.8-61.8-19.1c-14.3-4.9-33.1-12.4-47.1-18.1c-35.4-14.6-75.2-35.4-92.2-45.6c-11.5-6.8-27-15.6-38-23.2 c-10.8-7.4-25.4-17-36.1-24.7c-10.6-7.7-24.4-18.2-34.6-26.4c-29.4-23.7-50-43.4-63-56.2c-22.2-21.8-24.1-24.1-57.1-62.2 c-21.6-25-58.9-77.2-76.8-109.1c-13.9-24.7-31.3-58.4-43.5-84c-7-14.7-15.2-34.8-20.6-50.2c-5.9-17.1-13.8-39.9-19-57.2 c-4.7-15.9-9.7-37.4-13.7-53.4c-5.3-21.3-9.7-50.4-12.8-72.1c20.3,152.8,158.9,287.7,395.1,354.8 c-236.2-67-374.7-202-395.1-354.8c-3.5-35.8-8-83.8-7.4-119.7c0.9-49.7,3.8-82.9,11.8-132.7c5.1-32.1,15.1-74.4,25-105.4 c11.8-36.9,29.6-85.7,47.3-120.1c16.9-33,41-76.3,62.1-106.8c22.4-32.4,55-73.8,82.3-102.1c27.8-28.8,67.1-65.3,98.9-89.6 c48.7-37.2,76.4-52.8,118.2-76.3c31.6-17.8,76.4-36.5,110.4-49c30.6-11.3,72.5-23.9,104.5-30.1c35.7-6.9,83.7-15.3,120-17.3 c27.3-1.5,63.8-2,91.2-1.5c17.2,0.3,40.1,2.5,57.3,4.2c22.9,2.2,53.2,7.4,75.8,11.6c16.1,3,37.4,8.4,53.2,12.5 c18.8,4.8,43.4,12.8,61.8,19.1c14.3,4.9,33.1,12.4,47.1,18.1c35.4,14.6,75.2,35.4,92.2,45.6c11.5,6.8,27,15.6,38,23.2 c10.8,7.4,25.4,17,36.1,24.7c10.6,7.7,24.4,18.2,34.6,26.4c29.4,23.7,50,43.4,63,56.2c22.2,21.8,24.1,24.1,57.1,62.2 c21.7,25,58.9,77.3,76.8,109.1c13.9,24.7,31.3,58.4,43.5,84c7,14.7,15.2,34.8,20.6,50.2c5.9,17.1,13.8,39.9,19,57.2 c4.7,15.9,9.7,37.4,13.7,53.4C1725.8,738.8,1730.7,767.8,1733.3,789.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041266732213200583500000010204233566514487461_",
    gradientUnits: "userSpaceOnUse",
    x1: 553.7545,
    y1: 1321.4929,
    x2: 1151.5201,
    y2: 286.1324,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000041266732213200583500000010204233566514487461_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c-392.6-111.4-908.7,6.6-1150.4,263c49.3,370.5,408.2,761.3,801.4,872.9C1231,1314.3,1387.5,804.8,1338.3,434.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023985436372795688580000001755749986094309040_",
    gradientUnits: "userSpaceOnUse",
    x1: 819.8329,
    y1: 1023.5568,
    x2: 988.884,
    y2: 730.7518,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000023985436372795688580000001755749986094309040_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M506.3,491c42.6,319.8,352.4,657.2,691.9,753.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173143579156317596220000004798243070296786069_",
    gradientUnits: "userSpaceOnUse",
    x1: 630.9866,
    y1: 1202.2642,
    x2: 1157.0531,
    y2: 291.0903,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000173143579156317596220000004798243070296786069_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9C1024.1,525.3,571.9,807.6,330.2,1064"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019660753681624540740000006867182264065662654_",
    gradientUnits: "userSpaceOnUse",
    x1: 743.3071,
    y1: 1414.2717,
    x2: 1331.8997,
    y2: 394.7996,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000019660753681624540740000006867182264065662654_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c-155.6,263.1-478.9,685.9-720.5,942.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155148862932357362730000010036257853253538984_",
    gradientUnits: "userSpaceOnUse",
    x1: 1110.3566,
    y1: 1609.845,
    x2: 1706.5432,
    y2: 577.2196,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000155148862932357362730000010036257853253538984_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c49.3,369.9-107.3,879.5-348.9,1135.9c393.3,111.6,672.1-98.2,622.7-468.7 C1853.7,845.6,1730.9,546.3,1338.3,434.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068661858121185269300000008364273696658004377_",
    gradientUnits: "userSpaceOnUse",
    x1: 1412.6083,
    y1: 1335.8844,
    x2: 1724.9816,
    y2: 794.838,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000068661858121185269300000008364273696658004377_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1198.1,1244.5c339.5,96.4,580.2-84.8,537.6-404.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021839149965808646620000003525107648869307561_",
    gradientUnits: "userSpaceOnUse",
    x1: 1155.6547,
    y1: 1441.3367,
    x2: 1654.4158,
    y2: 577.4571,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000021839149965808646620000003525107648869307561_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c240.7,375.6,239.9,889.9-1.7,1146.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026843987768634472840000014632585413843002298_",
    gradientUnits: "userSpaceOnUse",
    x1: 1331.3459,
    y1: 1245.6332,
    x2: 1701.6212,
    y2: 604.2975,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000026843987768634472840000014632585413843002298_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c363.9,282.9,463.3,721.7,221.7,978.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049224090368239559340000007240188445335739532_",
    gradientUnits: "userSpaceOnUse",
    x1: 1184.2812,
    y1: 827.917,
    x2: 1509.9171,
    y2: 263.899,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000049224090368239559340000007240188445335739532_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c392.6,111.4,515.5,410.7,273.8,667.2c-49.3-370.5-408.2-761.3-801.4-872.9C1052.3-27.3,1289,65,1338.3,434.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172424133622444809130000005717280845984979841_",
    gradientUnits: "userSpaceOnUse",
    x1: 1372.675,
    y1: 596.3639,
    x2: 1541.7264,
    y2: 303.5584,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000172424133622444809130000005717280845984979841_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1735.7,839.9c-42.6-319.8-352.4-657.2-691.9-753.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073707203669489272410000011955894593865553286_",
    gradientUnits: "userSpaceOnUse",
    x1: 1426.1011,
    y1: 675.2684,
    x2: 1591.8363,
    y2: 388.2065,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000073707203669489272410000011955894593865553286_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c314.2-90.5,373.2,44.6,131.5,301"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118398083945071680400000016543070652178338717_",
    gradientUnits: "userSpaceOnUse",
    x1: 1302.8271,
    y1: 456.9375,
    x2: 1444.1643,
    y2: 212.1345,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000118398083945071680400000016543070652178338717_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9c155.6-263.1,85.6-268.6-156-12.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062169779036545606880000005374759871126868363_",
    gradientUnits: "userSpaceOnUse",
    x1: 571.4208,
    y1: 892.1445,
    x2: 1078.0831,
    y2: 14.5796,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000062169779036545606880000005374759871126868363_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9C1289,65,1052.3-27.3,810.6,229.2c-393.3-111.6-672.1,98.2-622.7,468.7C429.6,441.4,945.6,323.4,1338.3,434.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157282225046941443120000001582955292350121120_",
    gradientUnits: "userSpaceOnUse",
    x1: 636.5771,
    y1: 532.2776,
    x2: 948.9507,
    y2: -8.7693,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000157282225046941443120000001582955292350121120_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1043.9,86.3C704.4-10,463.7,171.1,506.3,491"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000074433706041246574810000015257626502459405711_",
    gradientUnits: "userSpaceOnUse",
    x1: 896.8682,
    y1: 433.5604,
    x2: 1075.3606,
    y2: 124.4025,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000074433706041246574810000015257626502459405711_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9C1097.6,59.3,705.1-37.7,463.4,218.8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067220180034579246050000018034362429292611001_",
    gradientUnits: "userSpaceOnUse",
    x1: 720.3411,
    y1: 628.7814,
    x2: 981.5249,
    y2: 176.3977,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000067220180034579246050000018034362429292611001_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1338.3,434.9C974.4,152,481.7,130.5,240,386.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093177156263063356610000008388856716360296838_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.5744,
    y1: 1532.3337,
    x2: 735.2106,
    y2: 968.3152,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000093177156263063356610000008388856716360296838_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M187.9,697.9c-241.7,256.5-118.8,555.8,273.8,667.2c49.3,369.9,286,462.2,527.6,205.7C596,1459.2,237.2,1068.4,187.9,697.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119112750364591765270000004363668009115760264_",
    gradientUnits: "userSpaceOnUse",
    x1: 377.7655,
    y1: 1492.6748,
    x2: 546.8171,
    y2: 1199.8689,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000119112750364591765270000004363668009115760264_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M64.2,960.1c42.6,319.8,352.3,657.2,691.9,753.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000142172610760910807930000014869658047953987485_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.4544,
    y1: 1510.9935,
    x2: 469.3853,
    y2: 1337.9081,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000142172610760910807930000014869658047953987485_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M162.5,1199.6c24.9,186.8,205.8,383.9,404.2,440.2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078004384121152333860000002015147454557191594_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.6547,
    y1: 1408.0264,
    x2: 493.3905,
    y2: 1120.9636,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000078004384121152333860000002015147454557191594_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M330.2,1064c-241.7,256.5-182.7,391.5,131.5,301"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151545149004966593490000008162913767973244819_",
    gradientUnits: "userSpaceOnUse",
    x1: 475.3268,
    y1: 1584.0977,
    x2: 616.6638,
    y2: 1339.2948,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000151545149004966593490000008162913767973244819_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M617.7,1377.2c-241.7,256.5-311.7,251-156-12.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101089186454357575730000008163283631605277339_",
    gradientUnits: "userSpaceOnUse",
    x1: 841.408,
    y1: 1781.653,
    x2: 1348.0707,
    y2: 904.0874,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000101089186454357575730000008163283631605277339_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M989.3,1570.8C747.7,1827.2,511,1735,461.7,1365.1c392.6,111.4,908.7-6.6,1150.4-263C1661.4,1472.6,1382.6,1682.4,989.3,1570.8 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000012460309552690846050000006900069416611782066_",
    gradientUnits: "userSpaceOnUse",
    x1: 970.5405,
    y1: 1805.0022,
    x2: 1282.9138,
    y2: 1263.9557,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000012460309552690846050000006900069416611782066_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M756.1,1713.6c339.5,96.4,580.2-84.8,537.6-404.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000077317470766597002350000001813685953393676945_",
    gradientUnits: "userSpaceOnUse",
    x1: 716.5959,
    y1: 1693.8905,
    x2: 900.2332,
    y2: 1375.8214,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000077317470766597002350000001813685953393676945_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M566.7,1639.8c198.3,56.3,338.9-49.5,314.1-236.4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136371110479139847970000017957989292504376998_",
    gradientUnits: "userSpaceOnUse",
    x1: 844.1307,
    y1: 1671.8302,
    x2: 1022.6234,
    y2: 1362.6716,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000136371110479139847970000017957989292504376998_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1336.5,1581.2c-241.7,256.5-634.1,159.5-874.8-216.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031191852881999392220000009598269173034057891_",
    gradientUnits: "userSpaceOnUse",
    x1: 937.9666,
    y1: 1619.8345,
    x2: 1199.1505,
    y2: 1167.4507,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000031191852881999392220000009598269173034057891_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1559.9,1413.1c-241.7,256.5-734.3,234.9-1098.2-48"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019647356283429695560000016481746526725815963_",
    gradientUnits: "userSpaceOnUse",
    x1: 767.9717,
    y1: 1510.0997,
    x2: 1365.7371,
    y2: 474.7397,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000019647356283429695560000016481746526725815963_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1612.1,1102.1c-241.7,256.5-757.7,374.4-1150.4,263C412.4,995.2,569,485.6,810.6,229.2 C1203.9,340.8,1562.7,731.6,1612.1,1102.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067231256600044448510000016269792104125874346_",
    gradientUnits: "userSpaceOnUse",
    x1: 930.6066,
    y1: 1065.4812,
    x2: 1099.658,
    y2: 772.6758,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000067231256600044448510000016269792104125874346_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1293.7,1309c-42.6-319.8-352.4-657.2-691.9-753.6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000045616693382272822880000010153510459137345673_",
    gradientUnits: "userSpaceOnUse",
    x1: 693.3974,
    y1: 1261.335,
    x2: 793.3286,
    y2: 1088.2491,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000045616693382272822880000010153510459137345673_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M880.8,1403.4c-24.9-186.8-205.8-383.9-404.2-440.2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072264026529656588690000007855711824537836680_",
    gradientUnits: "userSpaceOnUse",
    x1: 762.4385,
    y1: 1505.1418,
    x2: 1288.505,
    y2: 593.9679,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000072264026529656588690000007855711824537836680_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1469.8,735.9c-241.7,256.5-693.9,538.7-1008.1,629.2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000936449157247409010000012261620907947922081_",
    gradientUnits: "userSpaceOnUse",
    x1: 587.5916,
    y1: 1401.4323,
    x2: 1176.184,
    y2: 381.9605,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000000936449157247409010000012261620907947922081_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1182.2,422.8c-241.7,256.5-564.9,679.2-720.5,942.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023988345856949914750000013744062373357022614_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.9484,
    y1: 1219.0123,
    x2: 809.1345,
    y2: 186.3877,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000023988345856949914750000013744062373357022614_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M810.6,229.2C569,485.6,412.4,995.2,461.7,1365.1C69.1,1253.6-53.8,954.3,187.9,697.9C138.5,327.4,417.4,117.6,810.6,229.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052074357596015918180000006634159728663222176_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.5099,
    y1: 1001.3945,
    x2: 506.8828,
    y2: 460.3488,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000052074357596015918180000006634159728663222176_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M601.8,555.4C262.3,459.1,21.6,640.3,64.2,960.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026139594052004002200000011135045398100550835_",
    gradientUnits: "userSpaceOnUse",
    x1: 262.5495,
    y1: 1223.4215,
    x2: 446.1869,
    y2: 905.3522,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000026139594052004002200000011135045398100550835_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M476.6,963.2c-198.3-56.3-338.9,49.5-314.1,236.4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103263928373838963970000015480001619209667237_",
    gradientUnits: "userSpaceOnUse",
    x1: 265.0759,
    y1: 1218.7749,
    x2: 763.837,
    y2: 354.8954,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000103263928373838963970000015480001619209667237_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M463.4,218.8C221.8,475.2,221,989.5,461.7,1365.1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096740374174957764710000007669616601924759701_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.8704,
    y1: 1191.9346,
    x2: 588.1457,
    y2: 550.5989,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000096740374174957764710000007669616601924759701_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M240,386.9C-1.6,643.4,97.8,1082.2,461.7,1365.1"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147219372608666153530000002593995606038155710_",
    gradientUnits: "userSpaceOnUse",
    x1: 930.4275,
    y1: 1066.5186,
    x2: 1100.5259,
    y2: 771.8994,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000147219372608666153530000002593995606038155710_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1296.2,1311.6c-42.9-321.8-354.6-661.3-696.2-758.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000924237422946658550000005445380227358536093_",
    gradientUnits: "userSpaceOnUse",
    x1: 585.2461,
    y1: 1404.6053,
    x2: 1177.546,
    y2: 378.7119,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000000924237422946658550000005445380227358536093_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M458.9,1368c156.6-264.8,481.9-690.2,725.1-948.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104677437625849691130000012855593461915843494_",
    gradientUnits: "userSpaceOnUse",
    x1: 818.9655,
    y1: 1024.333,
    x2: 989.0641,
    y2: 729.7136,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000104677437625849691130000012855593461915843494_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M503.8,488.4c42.9,321.8,354.6,661.3,696.2,758.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124127052408653569380000004325432774068683429_",
    gradientUnits: "userSpaceOnUse",
    x1: 741.9446,
    y1: 1417.5201,
    x2: 1334.2445,
    y2: 391.6267,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000124127052408653569380000004325432774068683429_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M615.9,1380.2C859.1,1122.1,1184.4,696.7,1341,432"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052088694309759830570000016710367620858683298_",
    gradientUnits: "userSpaceOnUse",
    x1: 1304.9916,
    y1: 454.152,
    x2: 1447.2036,
    y2: 207.8336,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000052088694309759830570000016710367620858683298_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1184,419.7c243.2-258.1,313.6-252.6,157,12.2"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000067197098927375014280000001435933681405529517_",
    gradientUnits: "userSpaceOnUse",
    x1: 930.4275,
    y1: 1066.5186,
    x2: 1100.5259,
    y2: 771.8994,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000067197098927375014280000001435933681405529517_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1296.2,1311.6c-42.9-321.8-354.6-661.3-696.2-758.3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091728743868887310170000009767276990867464364_",
    gradientUnits: "userSpaceOnUse",
    x1: 585.2461,
    y1: 1404.6053,
    x2: 1177.546,
    y2: 378.7119,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000091728743868887310170000009767276990867464364_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M458.9,1368c156.6-264.8,481.9-690.2,725.1-948.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113344551958310050720000013220091865491179694_",
    gradientUnits: "userSpaceOnUse",
    x1: 741.9446,
    y1: 1417.5201,
    x2: 1334.2445,
    y2: 391.6267,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000113344551958310050720000013220091865491179694_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M615.9,1380.2C859.1,1122.1,1184.4,696.7,1341,432"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046326806099308692970000006333523645212281224_",
    gradientUnits: "userSpaceOnUse",
    x1: 1304.9916,
    y1: 454.152,
    x2: 1447.2036,
    y2: 207.8336,
    gradientTransform: "matrix(1 0 0 1 -59.7631 1.8628)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#88278E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03937514,
    style: {
      stopColor: "#8E2A87"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09865391,
    style: {
      stopColor: "#A03172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1705,
    style: {
      stopColor: "#BC3E50"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2514,
    style: {
      stopColor: "#E34F22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2942,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3757,
    style: {
      stopColor: "#F98007"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4528,
    style: {
      stopColor: "#F89E08"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4962,
    style: {
      stopColor: "#F8A908"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5384,
    style: {
      stopColor: "#F8A008"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6072,
    style: {
      stopColor: "#F98807"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6937,
    style: {
      stopColor: "#FA6006"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7082,
    style: {
      stopColor: "#FA5906"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7631,
    style: {
      stopColor: "#DB4C2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8372,
    style: {
      stopColor: "#B83C55"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#9E3074"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9605,
    style: {
      stopColor: "#8E2987"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#88278E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000046326806099308692970000006333523645212281224_)",
      strokeWidth: 7,
      strokeMiterlimit: 10
    },
    d: " M1184,419.7c243.2-258.1,313.6-252.6,157,12.2"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsfera);
export default __webpack_public_path__ + "static/media/esfera.aaa65432fc37040d380aa0b5b3a32761.svg";
export { ForwardRef as ReactComponent };